import dayjs from 'dayjs';
import { Statistics, ListPlayer, BetHistory } from '~/components/Action';
import { Money } from '~/components/Status';
import { formatDateTime, getDevice } from '~/utils/helper';
import { LuLayoutDashboard } from 'react-icons/lu';
import { GrVmMaintenance } from 'react-icons/gr';
import { GiTakeMyMoney } from 'react-icons/gi';
import { FcMoneyTransfer } from 'react-icons/fc';
import { RiHistoryFill } from 'react-icons/ri';
import { IoPricetagsOutline } from 'react-icons/io5';
import { Dashboard } from '~/pages/Home';
import { Recharge, Report, Withdraw } from '~/pages/Report';
import { Refund } from '~/pages/Refund';
import HistoryGiftCode from '~/pages/HistoryGiftCode';
import { FaWallet } from 'react-icons/fa';
import { BsGift } from 'react-icons/bs';
import HistoryChangeWallet from '~/pages/HistoryChangeWallet';
import { useTranslation } from 'react-i18next';
import DetailsReportMobile from '~/pages/Report/DetailsReportMobile';
import DetailsBetRecordMobile from '~/pages/Report/DetailsBetRecordMobile';
import DetailsRechargeMobile from '~/pages/Report/DetailRechargeMobile';
import DetailsRefundMobile from '~/pages/Refund/DetailRefundMobile';
import DetailsWithdrawMobile from '~/pages/Report/DetailWithdrawMobile';
import { formatMoney } from '~/contexts/ContextProvider';

export const Links = () => {
  const { t } = useTranslation('common');
  return [
    {
      label: 'Dashboard',
      key: '/',
      icon: <LuLayoutDashboard size={18} />,
      element: <Dashboard />,
    },
    {
      label: t('baocaodaily'),
      key: '/report',
      icon: <LuLayoutDashboard size={18} />,
      element: <Report />,
    },
    // {
    //   label: "Báo cáo đại lý",
    //   key: "/report/bet-history",
    //   icon: <LuLayoutDashboard />,
    //   component: BetHistory,
    // },
    {
      label: t('lsnaptien'),
      key: '/recharge',
      icon: <GiTakeMyMoney size={18} />,
      element: <Recharge />,
    },
    {
      label: t('lsruttien'),
      key: '/withdraw',
      icon: <FcMoneyTransfer size={18} />,
      element: <Withdraw />,
    },
    {
      label: t('lshoantra'),
      key: '/refund',
      icon: <RiHistoryFill size={18} />,
      element: <Refund />,
    },
    {
      label: t('lsgiftcode'),
      key: '/history-giftcode',
      icon: <BsGift size={18} />,
      element: <HistoryGiftCode />,
    },
    {
      label: t('lschinhvi'),
      key: '/history-change-wallet',
      icon: <FaWallet size={18} />,
      element: <HistoryChangeWallet />,
    },
  ];
};
export const navLink = [
  {
    title: 'Dashboard',
    href: '/',
  },
  {
    title: 'Báo cáo đại lý',
    href: '/report',
  },
  {
    title: 'Lịch sử nạp tiền',
    href: '/recharge',
  },
  {
    title: 'Lịch sử rút tiền',
    href: '/withdraw',
  },
  {
    title: 'Lịch sử Hoàn trả',
    href: '/refund',
  },
];

export function Analytics() {
  const { t } = useTranslation('dashboard');
  return [
    {
      name: t('thanhviendkihomnay'),
      data: 'todaylUser',
      type: 'number',
      color: 'bg-[#fc424a]',
    },

    {
      name: t('tongthanhvien'),
      data: 'totalUser',
      type: 'number',
      color: 'bg-[#fc424a]',
    },

    {
      name: t('tongtiennapthoigian'),
      data: 'timeDeposit',
      type: 'currency',
      color: 'bg-[#0090e7]',
    },

    {
      name: t('tongtienrutthoigian'),
      data: 'timeWithdrawl',
      type: 'currency',
      color: 'bg-[#ffab00]',
    },

    {
      name: t('tonghoantrathoigian'),
      data: 'timeRefund',
      type: 'currency',
      color: 'bg-green-500',
    },
    {
      name: t('tongkhuyenmaithoigian'),
      data: 'timePromotion',
      type: 'currency',
      color: 'bg-slate-400',
    },
    {
      name: t('tongcuocthoigian'),
      data: 'timeBet',
      type: 'currency',
      color: 'bg-[#484bf0]',
    },
    {
      name: t('tongthangthoigian'),
      data: 'timeWin',
      type: 'currency',
      color: 'bg-rose-400',
    },
    {
      name: t('tongthuathoigian'),
      data: 'timeLoss',
      type: 'currency',
      color: 'bg-orange-500',
    },
  ];
}

export const homeGrid = [
  {
    title: 'ID đại lý/Tên thật',
    dataIndex: ['', 'id'],
    render: (_, data) => (
      <div className="flex flex-col items-center justify-center">
        <span>{data.id}</span>
        <span>{data.name}</span>
      </div>
    ),
  },
  {
    title: 'Số lượng đại lý tuyến dưới',
    dataIndex: 'totalNumber1',
  },
  {
    title: 'Tổng số người đăng ký',
    dataIndex: 'totalNumber2',
  },
  {
    title: 'Tổng số người chơi',
    dataIndex: 'totalPlayer',
  },
  {
    title: 'Số tiền nạp',
    dataIndex: 'recharge',
    render: (data) => <span>{formatMoney(data)}</span>,
  },
  {
    title: 'Số tiền rút',
    dataIndex: 'withdrawal',
    render: (data) => <span>{formatMoney(data)}</span>,
  },
  {
    title: 'Điều chỉnh bằng tay',
    dataIndex: 'handEdit',
  },
  {
    title: 'Tổng số tiền đặt cược',
    dataIndex: 'totalBet',
    render: (data) => <span>{formatMoney(data)}</span>,
  },
  {
    title: 'Cược hợp lệ',
    dataIndex: 'legitBet',
  },
  {
    title: 'Tổng số thắng thua',
    dataIndex: ['', 'id'],
    render: (_, data) => (
      <span>
        {data.win}/{data.lose}
      </span>
    ),
  },
  {
    title: 'Tổng khách hàng',
    dataIndex: ['', 'id'],
    render: (_, data) => <ListPlayer data={data} />,
  },
  {
    title: 'Thống kê',
    dataIndex: ['', 'id'],
    render: (_, data) => <Statistics data={data} />,
  },
  {
    title: 'Hoàn trả',
    dataIndex: ['', 'id'],
    render: (_, data) => <span>Xem</span>,
  },
];

export const dataHomeGrid = [
  {
    id: 0,
    name: 'Nông A Dền',
    totalNumber1: 2,
    totalNumber2: 2,
    totalPlayer: 2,
    recharge: 1000000,
    withdrawal: 1000000,
    handEdit: 0,
    totalBet: 20000000,
    legitBet: 1,
    win: 4,
    lose: 4,
  },
  {
    id: 1,
    name: 'Dên A nồng',
    totalNumber1: 2,
    totalNumber2: 2,
    totalPlayer: 2,
    recharge: 1000000,
    withdrawal: 1000000,
    handEdit: 0,
    totalBet: 20000000,
    legitBet: 1,
    win: 8,
    lose: 3,
  },
];

export const ListPlayerGrid = () => {
  const { t } = useTranslation('report');
  return [
    {
      title: t('username'),
      dataIndex: 'username',
      // render: (_, data) => <BetHistory data={data} />,
    },
    {
      title: t('level'),
      dataIndex: 'levelDaily',
    },
    {
      title: t('solannap'),
      dataIndex: 'totalTimesRecharge',
    },
    {
      title: t('sotiennap'),
      dataIndex: 'totalRecharge',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('solanrut'),
      dataIndex: 'totalTimesWithdrawal',
    },
    {
      title: t('sotienrut'),
      dataIndex: 'totalWithdraw',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('dieuchinhbangtay'),
      dataIndex: 'handEdit',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('sotiendatcuoc'),
      dataIndex: 'totalBetHistory',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('cuochople'),
      dataIndex: 'legitBet',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('thangthua'),
      dataIndex: ['', 'id'],
      render: (_, data) => (
        <span>
          {formatMoney(data.totalBetWin)}/{formatMoney(data.totalBetLose)}
        </span>
      ),
    },
    {
      title: t('hoantra'),
      dataIndex: 'totalRefund',
      render: (_, data) => <span>{formatMoney(_)}</span>,
    },
    {
      title: t('khuyenmai'),
      dataIndex: 'totalGiftCode',
      render: (_, data) => <span>{formatMoney(_)}</span>,
    },
    {
      title: t('sodu'),
      dataIndex: 'money',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('ngaydangky'),
      dataIndex: 'created_at',
      render: (data) => <span>{dayjs(data).format('DD/MM/YYYY')}</span>,
    },
    {
      title: t('hanhdong'),
      dataIndex: ['', 'id'],
      render: (_, data) => <BetHistory data={data} />,
    },

    // {
    //     title: 'Tiền bo',
    //     dataIndex: 'tips',
    //     render: (data) => <span>{formatMoney(data)}</span>,
    // },
    // {
    //     title: 'Hoàn trả',
    //     dataIndex: ['', 'id'],
    //     render: (_, data) => <span>Chưa có</span>,
    // },
  ];
};

export const ListPlayerGridMobile = () => {
  const { t } = useTranslation('report');
  return [
    {
      title: t('username'),
      dataIndex: 'username',
      // render: (_, data) => <BetHistory data={data} />,
    },
    {
      title: t('sodu'),
      dataIndex: 'money',
      render: (data) => <span>{formatMoney(data)}</span>,
    },
    {
      title: t('ngaydangky'),
      dataIndex: 'created_at',
      render: (data) => <span>{dayjs(data).format('DD/MM/YYYY')}</span>,
    },
    {
      title: t('hanhdong'),
      dataIndex: ['', 'id'],
      render: (_, data) => <DetailsReportMobile data={data} />,
    },

    // {
    //     title: 'Tiền bo',
    //     dataIndex: 'tips',
    //     render: (data) => <span>{formatMoney(data)}</span>,
    // },
    // {
    //     title: 'Hoàn trả',
    //     dataIndex: ['', 'id'],
    //     render: (_, data) => <span>Chưa có</span>,
    // },
  ];
};

export const dataListPlayerGrid = [
  {
    id: 0,
    name: 'Nông A Dền',
    levelGroup: 'Nhóm 1',
    totalTimeRecharge: 2,
    totalTimeWithdrawal: 2,
    totalPlayer: 2,
    recharge: 1000000,
    withdrawal: 1000000,
    handEdit: 0,
    totalBet: 20000000,
    legitBet: 1,
    tips: 1000000,
    win: 4,
    lose: 4,
  },
  {
    id: 1,
    name: 'Dên A nồng',
    totalTimeRecharge: 2,
    totalTimeWithdrawal: 2,
    totalPlayer: 2,
    recharge: 1000000,
    withdrawal: 1000000,
    handEdit: 0,
    totalBet: 20000000,
    legitBet: 1,
    tips: 1000000,
    win: 8,
    lose: 3,
  },
];

export const DepositGrid = (isDeposit = true) => {
  const device = getDevice();
  const { t } = useTranslation('report');
  return [
    {
      title: t('nguoichoi'),
      dataIndex: 'username',
    },
    {
      title: t('sotien'),
      dataIndex: 'amount',
      render: (data) => {
        const money = formatMoney(data);
        return <p style={{ color: 'red' }}>{money}</p>;
      },
    },
    {
      title: t('trangthai'),
      dataIndex: 'status',
      render: (data) => <Money status={data} />,
    },

    // {
    //   title: "Loại thanh toán",
    //   dataIndex: "type",
    // },
    {
      title: t('ngaytao'),
      dataIndex: 'created_at',
      render: (data) => (
        <div className="flex mobile:flex-col">
          <p className="mr-2">{dayjs(data).format('HH:mm:ss')}</p>
          <p>{dayjs(data).format('DD/MM/YYYY')}</p>
        </div>
      ),
    },
    ...(device === 'desktop'
      ? [
          {
            title: t('magiaodich'),
            dataIndex: 'id',
          },
          {
            title: t('noidung'),
            dataIndex: 'id_txn',
          },
          {
            title: t('nganhang'),
            dataIndex: 'bank',
          },
          {
            title: t('hoten'),
            dataIndex: 'bank_account',
          },
          {
            title: t('stk'),
            dataIndex: 'bank_number',
          },
        ]
      : [
          {
            title: 'Thao tác',
            dataIndex: 'id',
            render: (_, record) =>
              isDeposit ? (
                <DetailsRechargeMobile data={record} />
              ) : (
                <DetailsWithdrawMobile data={record} />
              ),
          },
        ]),
  ];
};
export const BetHistoryGrid = (game) => {
  const device = getDevice();
  const { t } = useTranslation('report');
  const GAMES_XOCDIA = [
    {
      name: `${t('xocdia')} 30 ${t('second')}`,
      value: 30,
      type: 'xocdia',
      label: `30 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} 45 ${t('second')}`,
      value: 45,
      type: 'xocdia',
      label: `45 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} 60 ${t('second')}`,
      value: 60,
      type: 'xocdia',
      label: `60 ${t('second')}`,
    },
    {
      name: `${t('xocdia')} BlockChain 30 ${t('second')} - ${t('table')} A`,
      value: '30-A',
      type: 'xocdia_blockchain',
      label: `BlockChain 30 ${t('second')} - ${t('table')} A`,
    },
    {
      name: `${t('xocdia')} BlockChain 30 ${t('second')} - ${t('table')} B`,
      value: '30-B',
      type: 'xocdia_blockchain',
      label: `BlockChain 30 ${t('second')} - ${t('table')} B`,
    },
  ];

  const listGame = ListGameXoso();
  const a = {
    api: [
      // {
      //   title: t("nguoichoi"),
      //   dataIndex: "member",
      // },
      {
        title: t('magame'),
        dataIndex: 'product',
      },
      {
        title: t('tiencuoc'),
        dataIndex: 'bet',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('thanhtoan'),
              dataIndex: 'payout',
              render: (data) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('doanhso'),
              dataIndex: 'turnover',
              render: (data, record) => {
                const money = formatMoney(data ? data : record?.bet);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('phien'),
              dataIndex: 'ref_no',
            },
          ]
        : []),
      {
        title: t('hoantra', { ns: 'common' }),
        dataIndex: 'commission',
        render: (_) => <span>{formatMoney(_ || 0)}</span>,
      },
      {
        title: t('thoigian'),
        dataIndex: 'start_time',
        render: (data) => (
          <div className="flex mobile:flex-col">
            <p className="mr-2">{dayjs(data).format('HH:mm:ss')}</p>
            <p>{dayjs(data).format('DD/MM/YYYY')}</p>
          </div>
        ),
      },
      ...(device === 'mobile'
        ? [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]
        : []),
    ],
    xoso: [
      // {
      //   title: t("nguoichoi"),
      //   dataIndex: "username",
      // },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => (
          <span>{listGame?.find((item) => item.value === data)?.name || data}</span>
        ),
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('kieu'),
              dataIndex: 'type',
              render: (data) => <p>{t(`${data}`)}</p>,
            },
            {
              title: t('tiencuoc'),
              dataIndex: 'amount',
              render: (data) => {
                const money = formatMoney(data);
                return <p style={{ color: 'red' }}>{money}</p>;
              },
            },
            {
              title: t('cuadat'),
              dataIndex: 'so',
              render: (data) => {
                const arr = JSON.parse(data);
                const text = arr.map((item) => t(`${item}`));
                return (
                  <div className="overflow-hidden whitespace-nowrap text-ellipsis max-w-[25dvw]">
                    {text.toString().replace(',', ', ')}
                  </div>
                );
              },
            },
          ]
        : []),

      {
        title: t('tongcuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'green' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    sicbo: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          return isNaN(data) ? data : data + ' ' + t(`second`);
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                return t(`${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'money',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    xocdia: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          const result = GAMES_XOCDIA?.find((item) => item?.value?.toString() === data);
          return <span>{result ? result?.label : 'Unknown'}</span>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                return t(`xocdiadetail.${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    xocdia_blockchain: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          const result = GAMES_XOCDIA?.find((item) => item?.value?.toString() === data);
          return <span>{result ? result?.label : 'Unknown'}</span>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                return t(`xocdiadetail.${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    baccarat_blockchain: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          const second = data?.split('-')[0];
          const table = data?.split('-')[1];
          return <span>{`${second} ${t('second')} - ${t('table')} ${table}`}</span>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                return t(`baccaratDetail.${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    baucua: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          return data + ' ' + t(`second`);
        },
      },

      ...(device === 'desktop'
        ? [
            {
              title: t('kieu'),
              dataIndex: 'cachchoi',
              render: (data) => {
                return t(`${data}`);
              },
            },
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                if (data === 'red,blue,green')
                  return t(`red`) + ', ' + t(`green`) + ', ' + t(`blue`);
                return t(`${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },

      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    rongho: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          return data + ' ' + t(`second`);
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('cuadat'),
              dataIndex: 'cuadat',
              render: (data) => {
                return t(`ronghodetail.${data}`);
              },
            },
          ]
        : []),

      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },

      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
    keno: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          return data / 60 + ' ' + t(`minute`);
        },
      },
      {
        title: t('cuadat'),
        dataIndex: 'cuadat',
        render: (data) => {
          return t(`common:${data}`);
        },
      },
      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      {
        title: t('doanhso'),
        dataIndex: 'win',
        render: (data, record) => {
          const money = formatMoney(data);
          return <p style={{ color: 'green' }}>{money}</p>;
        },
      },
      {
        title: t('thoigian'),
        dataIndex: 'created_at',
        render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
      },
    ],
    mega: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
      },
      {
        title: t('theloai'),
        dataIndex: 'theloai',
        render: (data) => {
          return data + ' ' + t(`minute`);
        },
      },
      {
        title: t('cuadat'),
        dataIndex: 'cuadat',
        render: (data) => {
          return t(`${data}`);
        },
      },
      {
        title: t('tiencuoc'),
        dataIndex: 'cuoc',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      {
        title: t('doanhso'),
        dataIndex: 'win',
        render: (data, record) => {
          const money = formatMoney(data);
          return <p style={{ color: 'green' }}>{money}</p>;
        },
      },
      {
        title: t('thoigian'),
        dataIndex: 'created_at',
        render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
      },
    ],
    quyetchien: [
      {
        title: t('nguoichoi'),
        dataIndex: 'username',
      },
      {
        title: t('phien'),
        dataIndex: 'phien',
        render: (text) => text.split('_')[1],
      },

      {
        title: t('tiencuoc'),
        dataIndex: 'betAmount',
        render: (data) => {
          const money = formatMoney(data);
          return <p style={{ color: 'red' }}>{money}</p>;
        },
      },
      ...(device === 'desktop'
        ? [
            {
              title: t('doanhso'),
              dataIndex: 'win',
              render: (data, record) => {
                const money = formatMoney(data);
                return <p style={{ color: 'green' }}>{money}</p>;
              },
            },
            {
              title: t('thoigian'),
              dataIndex: 'created_at',
              render: (data) => dayjs(data).format('DD/MM/YYYY HH:mm:ss'),
            },
          ]
        : [
            {
              title: 'Thao tác',
              dataIndex: 'id',
              render: (_, record) => <DetailsBetRecordMobile data={record} game={game} />,
            },
          ]),
    ],
  };
  return a[game];
};
export const ListGameXoso = () => {
  const { t } = useTranslation('report');
  const result = [
    {
      name: `${t('mienbac')} 75 ${t('second')}`,
      value: '75_mb',
    },
    {
      name: `VIP ${t('mienbac')} 75 ${t('second')}`,
      value: '75_vip_mb',
    },
    {
      name: `VIP ${t('mienbac')} 3 ${t('minute')}`,
      value: '180_vip_mb',
    },
    {
      name: `VIP ${t('miennam')} 45 ${t('second')}`,
      value: '45_vip_mn',
    },
    {
      name: `${t('sieutoc')} ${t('miennam')} 45 ${t('second')}`,
      value: '45_st_mn',
    },
    {
      name: `VIP ${t('mientrung')} 75 ${t('second')}`,
      value: '75_vip_mt',
    },
    {
      name: `${t('mientrung')} 75 ${t('second')}`,
      value: '75_mt',
    },
    {
      name: `${t('sieutoc')} 45 ${t('second')}`,
      value: '45_st',
    },
    {
      name: `${t('sieutoc')} 1 ${t('minute')}`,
      value: '60_st',
    },
    {
      name: `${t('sieutoc')} 1.5 ${t('minute')}`,
      value: '90_st',
    },
    {
      name: `${t('sieutoc')} 2 ${t('minute')}`,
      value: '120_st',
    },
    {
      name: `${t('sieutoc')} 5 ${t('minute')}`,
      value: '300_st',
    },
    {
      name: `${t('sieutoc')} VIP 45 ${t('second')}`,
      value: '45_st_vip',
    },
    {
      name: `${t('sieutoc')} VIP 1 ${t('minute')}`,
      value: '60_st_vip',
    },
    {
      name: `${t('sieutoc')} VIP 1.5 ${t('minute')}`,
      value: '90_st_vip',
    },
    {
      name: `${t('sieutoc')} VIP 2 ${t('minute')}`,
      value: '120_st_vip',
    },
    {
      name: `${t('sieutoc')} VIP 5 ${t('minute')}`,
      value: '300_st_vip',
    },
  ];
  return result;
};
export const HistoryRefundGrid = () => {
  const device = getDevice();
  const { t } = useTranslation('report');
  return [
    {
      title: t('username'),
      dataIndex: 'username',
    },
    {
      title: t('tongcuoc'),
      dataIndex: 'total_bet',
      render: (data) => <p>{formatMoney(data)}</p>,
    },

    {
      title: t('sotien'),
      dataIndex: 'amount',
      render: (data) => <p>{formatMoney(data)}</p>,
    },

    ...(device === 'desktop'
      ? [
          {
            title: t('tennhomhoantra'),
            dataIndex: 'provider_code',
          },
          {
            title: t('thoigiantu'),
            dataIndex: 'from',
          },
          {
            title: t('thoigianden'),
            dataIndex: 'to',
          },
        ]
      : []),
    {
      title: t('ngayhoantra'),
      dataIndex: 'created_at',
      render: (data) => (
        <div className="flex justify-center mobile:flex-col">
          {/* <p className="mr-2">{dayjs(data).format("HH:mm:ss")}</p> */}
          <p>{dayjs(data).format('DD/MM/YYYY')}</p>
        </div>
      ),
    },
    ...(device === 'desktop'
      ? []
      : [
          {
            title: 'Thao tác',
            dataIndex: 'id',
            render: (_, record) => <DetailsRefundMobile data={record} />,
          },
        ]),
  ];
};

export const HistoryGiftCodeGrid = () => {
  const { t } = useTranslation('report');
  return [
    {
      title: t('username'),
      dataIndex: 'username',
    },
    {
      title: t('macode'),
      dataIndex: 'code',
    },
    {
      title: t('tienthuong'),
      dataIndex: 'money',
      render: (data) => <p>{formatMoney(data)}</p>,
    },

    {
      title: t('thoigian'),
      dataIndex: 'created_at',
      render: (data) => (
        <div className="flex justify-center mobile:flex-col">
          <p className="mr-2">{dayjs(data).format('HH:mm:ss')}</p>
          <p>{dayjs(data).format('DD/MM/YYYY')}</p>
        </div>
      ),
    },
  ];
};

export const HistoryChangeWalletGrid = () => {
  const device = getDevice();
  const { t } = useTranslation('report');
  return [
    {
      title: t('nguoichoi'),
      dataIndex: 'username',
      key: 'username',
    },

    ...(device === 'desktop'
      ? [
          {
            title: t('truockhithaydoi'),
            dataIndex: 'before',
            key: 'before',
            render: (_) => formatMoney(_),
          },
          {
            title: t('saukhithaydoi'),
            dataIndex: 'after',
            key: 'after',
            render: (_) => formatMoney(_),
          },
        ]
      : []),

    {
      title: t('thaydoi'),
      dataIndex: 'after',
      key: 'after',
      render: (_, data) => formatMoney(data?.after - data?.before),
    },

    ...(device === 'desktop'
      ? [
          {
            title: t('lydo'),
            key: 'reason',
            dataIndex: 'reason',
          },
        ]
      : []),
    {
      title: t('thoigian'),
      key: 'created_at',
      dataIndex: 'created_at',
      render: (_) => dayjs(_).format('DD-MM-YYYY HH:mm:ss'),
    },
    ...(device === 'desktop'
      ? []
      : [
          {
            title: 'Thao tác',
            dataIndex: 'id',
            render: (_, record) => <DetailsRechargeMobile data={record} />,
          },
        ]),
  ];
};
